export function createTaskListApi({ role, apiUrl, getToken }) {
    const isAdmin = role === "admin";

    const headers = (json = true) => {
        const h = { Authorization: `Bearer ${getToken()}` };
        if (json) h["Content-Type"] = "application/json";
        return h;
    };

    return {
        async fetchLists() {
            const path = isAdmin ? `${apiUrl}/task-list` : `${apiUrl}/task-list/stafflistdata`;
            const res = await fetch(path, { headers: headers(false) });
            const data = await res.json();
            if (!res.ok) throw new Error(data.message || "Failed to fetch lists");
            return data.data || [];
        },

        async createList(payload) {
            const path = isAdmin ? `${apiUrl}/task-list` : `${apiUrl}/task-list/createlist`;
            const res = await fetch(path, {
                method: "POST",
                headers: headers(),
                body: JSON.stringify(payload),
            });
            const data = await res.json();
            if (!res.ok) throw new Error(data.message || "Failed to create list");
            return data.data;
        },

        async updateList(listId, payload) {
            const path = isAdmin
                ? `${apiUrl}/task-list/${listId}`
                : `${apiUrl}/task-list/edit-list/${listId}`;
            const res = await fetch(path, {
                method: "PUT",
                headers: headers(),
                body: JSON.stringify(payload),
            });
            const data = await res.json();
            if (!res.ok) throw new Error(data.message || "Failed to update list");
            return data;
        },

        async deleteList(listId) {
            const path = isAdmin
                ? `${apiUrl}/task-list/${listId}`
                : `${apiUrl}/task-list/delete-list/${listId}`;
            const res = await fetch(path, { method: "DELETE", headers: headers(false) });
            const data = await res.json().catch(() => ({}));
            if (!res.ok) throw new Error(data.message || "Failed to delete list");
            return data;
        },
    };
}
